/**
 * Get the page number from the url.
 * Get the page number from a pagination url included in a response.
 * @param url path
 * @returns page number
 */
export default function getNextPage(url: string | null | undefined): number {
  const defaultPage = 1;

  if (!url) {
    return defaultPage;
  }

  const path = '&page=';
  const match = url.match(`(${path}[0-9]{1,3})`);

  if (match?.length) {
    return parseInt(match[0].replace(path, ''));
  }

  return defaultPage;
}
